import React from "react";
import { Link } from "react-router-dom";
import DisputeManager from "../../assets/images/dispute-manager.png";
import ReputationManager from "../../assets/images/Reputation-manager.png";
import AnalyticsInsights from "../../assets/images/analytics-insights.png";
import PromotionManager from "../../assets/images/Promotion_manager.png"
import Finance from "../../assets/images/Finance Reco Upsell Graphic.png";
import DowntimeController from "../../assets/images/dc_product_page.webp"
import DC_Icon_P from "../../assets/images/DC_icon_purple.svg"
import { logGoogleEvent } from "../../firebase";

const Section2 = () => {
  return (
    <>
      <div className="container-fluid p-s2-container">
        <div
          className="row f-width m-auto products-row"
          style={{ backgroundColor: "#EDF4FF" }}
        >
          <div className="col-lg-4 col-sm-6">
            <div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_1983_3426"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="32"
                  height="32"
                >
                  <rect width="32" height="32" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1983_3426)">
                  <mask
                    id="mask1_1983_3426"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="32"
                    height="32"
                  >
                    <rect width="32" height="32" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask1_1983_3426)">
                    <path
                      d="M11.1284 18.0768H20.8719V17.5999C20.8719 16.7589 20.4193 16.0726 19.5142 15.541C18.6091 15.0094 17.4377 14.7436 16.0001 14.7436C14.5625 14.7436 13.3912 15.0094 12.4861 15.541C11.5809 16.0726 11.1284 16.7589 11.1284 17.5999V18.0768ZM16.0001 12.9999C16.648 12.9999 17.1988 12.773 17.6527 12.3192C18.1065 11.8654 18.3334 11.3145 18.3334 10.6666C18.3334 10.0188 18.1065 9.46793 17.6527 9.01411C17.1988 8.56027 16.648 8.33334 16.0001 8.33334C15.3523 8.33334 14.8014 8.56027 14.3476 9.01411C13.8938 9.46793 13.6668 10.0188 13.6668 10.6666C13.6668 11.3145 13.8938 11.8654 14.3476 12.3192C14.8014 12.773 15.3523 12.9999 16.0001 12.9999ZM8.05143 23.3333L5.38223 26.0025C5.00274 26.3819 4.56642 26.4678 4.07326 26.2601C3.58009 26.0525 3.3335 25.6785 3.3335 25.1384V5.74361C3.3335 5.0701 3.56683 4.50001 4.0335 4.03334C4.50016 3.56668 5.07025 3.33334 5.74376 3.33334H26.2565C26.93 3.33334 27.5001 3.56668 27.9668 4.03334C28.4334 4.50001 28.6668 5.0701 28.6668 5.74361V20.923C28.6668 21.5965 28.4334 22.1666 27.9668 22.6333C27.5001 23.0999 26.93 23.3333 26.2565 23.3333H8.05143ZM6.2566 21.3333H26.2565C26.3591 21.3333 26.4531 21.2906 26.5386 21.2051C26.6241 21.1196 26.6668 21.0256 26.6668 20.923V5.74361C26.6668 5.64103 26.6241 5.547 26.5386 5.46151C26.4531 5.37604 26.3591 5.33331 26.2565 5.33331H5.74376C5.64119 5.33331 5.54715 5.37604 5.46166 5.46151C5.3762 5.547 5.33346 5.64103 5.33346 5.74361V22.2564L6.2566 21.3333Z"
                      fill="#1C64F2"
                    />
                  </g>
                </g>
              </svg>
              <font className="p-head-text ps-2" style={{ color: "#1C64F2" }}>
              AI-Powered Dispute Resolution
              </font>
            </div>
            <p className="p-sub-heading ">
              Take Control of Your Revenue with Dispute Manager
            </p>
            <div
              className="p-sub-head-bdr"
              style={{ backgroundColor: "#1C64F2" }}
            ></div>
            <p className="p-body-text">
              Don't let unjust chargebacks eat into your profits. Our Dispute
              Manager tool helps you{" "}
              <font className="fw-bold">
                identify, track, and dispute unwarranted chargebacks across all
                marketplaces
              </font>
              . With Voosh, you can protect your revenue and ensure you get paid
              for every order.
            </p>
            <Link to="/dispute-manager" onClick={() => {
                    logGoogleEvent("Product features [Dispute manager link pressed]", {
                      name: "About us [Dispute manager link pressed]",
                    });
                  }}>
              <div className="btn btn-outline-primary btn-with-arrow mt-32">
                <font className="pe-2">View Details</font>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path d="M21.5 12H3.5H21.5Z" fill="white" />
                  <path
                    className="stroke-blue"
                    d="M14.5 5L21.5 12M21.5 12L14.5 19M21.5 12H3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-lg-8 col-sm-6">
            <div className="img-dispute">
              <img
                className="img-fluid"
                src={DisputeManager}
                alt="Voosh Dispute Manager"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Voosh Dispute Manager section ends */}

      <div className="container-fluid p-s2-container">
        <div
          className="row f-width m-auto products-row"
          style={{ backgroundColor: "#F5ECFF" }}
        >
          <div className="col-lg-4 col-sm-6">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <mask
                  id="mask0_1983_2244"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="32"
                  height="32"
                >
                  <rect width="32" height="32" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1983_2244)">
                  <path
                    d="M5.74425 25.9999C5.07074 25.9999 4.50065 25.7666 4.03398 25.2999C3.56732 24.8333 3.33398 24.2632 3.33398 23.5897V8.41027C3.33398 7.73676 3.56732 7.16667 4.03398 6.7C4.50065 6.23333 5.07074 6 5.74425 6H26.257C26.9305 6 27.5006 6.23333 27.9673 6.7C28.4339 7.16667 28.6673 7.73676 28.6673 8.41027V23.5897C28.6673 24.2632 28.4339 24.8333 27.9673 25.2999C27.5006 25.7666 26.9305 25.9999 26.257 25.9999H5.74425ZM5.74425 24H26.257C26.3596 24 26.4536 23.9572 26.5391 23.8718C26.6246 23.7863 26.6673 23.6922 26.6673 23.5897V8.41027C26.6673 8.30769 26.6246 8.21366 26.5391 8.12817C26.4536 8.0427 26.3596 7.99997 26.257 7.99997H5.74425C5.64167 7.99997 5.54764 8.0427 5.46215 8.12817C5.37668 8.21366 5.33395 8.30769 5.33395 8.41027V23.5897C5.33395 23.6922 5.37668 23.7863 5.46215 23.8718C5.54764 23.9572 5.64167 24 5.74425 24ZM13.6673 19H9.33395C9.0502 19 8.8126 19.0957 8.62115 19.2872C8.42971 19.4786 8.33398 19.7162 8.33398 20C8.33398 20.2837 8.42971 20.5213 8.62115 20.7128C8.8126 20.9042 9.0502 20.9999 9.33395 20.9999H11.0007V21.3333C11.0007 21.6171 11.0964 21.8547 11.2878 22.0461C11.4793 22.2375 11.7169 22.3333 12.0006 22.3333C12.2844 22.3333 12.522 22.2375 12.7134 22.0461C12.9049 21.8547 13.0006 21.6171 13.0006 21.3333V20.9999H14.4878C14.8228 20.9999 15.1032 20.8871 15.3288 20.6615C15.5544 20.4359 15.6673 20.1555 15.6673 19.8205V16.1795C15.6673 15.8444 15.5544 15.5641 15.3288 15.3384C15.1032 15.1128 14.8228 15 14.4878 15H10.3339V12.9999H14.6673C14.951 12.9999 15.1886 12.9042 15.3801 12.7128C15.5715 12.5213 15.6673 12.2837 15.6673 12C15.6673 11.7162 15.5715 11.4786 15.3801 11.2872C15.1886 11.0957 14.951 11 14.6673 11H13.0006V10.6666C13.0006 10.3829 12.9049 10.1453 12.7134 9.95384C12.522 9.76239 12.2844 9.66667 12.0006 9.66667C11.7169 9.66667 11.4793 9.76239 11.2878 9.95384C11.0964 10.1453 11.0007 10.3829 11.0007 10.6666V11H9.51345C9.17841 11 8.89806 11.1128 8.67242 11.3384C8.4468 11.5641 8.33398 11.8444 8.33398 12.1795V15.8205C8.33398 16.1555 8.4468 16.4359 8.67242 16.6615C8.89806 16.8871 9.17841 16.9999 9.51345 16.9999H13.6673V19ZM21.5417 21.2794L23.1775 19.6436C23.2801 19.541 23.3057 19.4295 23.2545 19.3089C23.2032 19.1884 23.1083 19.1282 22.9698 19.1282H19.6981C19.5596 19.1282 19.4647 19.1884 19.4135 19.3089C19.3622 19.4295 19.3878 19.541 19.4904 19.6436L21.1263 21.2794C21.1844 21.3376 21.2536 21.3666 21.334 21.3666C21.4143 21.3666 21.4835 21.3376 21.5417 21.2794ZM19.6981 13.2051H22.9698C23.1083 13.2051 23.2032 13.1448 23.2545 13.0243C23.3057 12.9038 23.2801 12.7923 23.1775 12.6897L21.5417 11.0538C21.4835 10.9957 21.4143 10.9666 21.334 10.9666C21.2536 10.9666 21.1844 10.9957 21.1263 11.0538L19.4904 12.6897C19.3878 12.7923 19.3622 12.9038 19.4135 13.0243C19.4647 13.1448 19.5596 13.2051 19.6981 13.2051Z"
                    fill="#9061F9"
                  />
                </g>
              </svg>
              <span className="p-head-text ps-2" style={{ color: "#7E3AF2" }}>
                FINANCE & RECONCILIATION
              </span>
            </div>
            <p className="p-sub-heading">
              Total Financial Clarity
            </p>
            <div
              className="p-sub-head-bdr"
              style={{ backgroundColor: "#7E3AF2" }}
            ></div>
            <p className="p-body-text">
            Get a clear breakdown of your actual versus expected payouts. <strong>Our Finance Reconciliation Dashboard</strong> provides <strong>instant insights into discrepancies</strong>, helping you track every dollar across all delivery platforms.
            </p>
            <Link to="/finance" onClick={() => {
                    logGoogleEvent("Product features [Finance manager link pressed]", {
                      name: "About us [Finance manager link pressed]",
                    });
                  }}>
              <div className="btn btn-outline-primary btn-with-arrow mt-32">
                <font className="pe-2">View Details</font>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path d="M21.5 12H3.5H21.5Z" fill="white" />
                  <path
                    className="stroke-blue"
                    d="M14.5 5L21.5 12M21.5 12L14.5 19M21.5 12H3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-lg-8 col-sm-6">
            <div className="finance">
              <img
                className="img-fluid"
                src={Finance}
                alt="Reputation manager"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Voosh financial and recon section ends */}
      
      <div className="container-fluid p-s2-container">
        <div
          className="row f-width m-auto products-row ps-0"
          style={{ backgroundColor: "#F5ECFF" }}
        >
          <div className="col-lg-4 col-sm-6 order-lg-2 order-sm-1">
            <div className="d-flex">
              <img src={DC_Icon_P} style={{paddingBottom:"5px"}} alt="downtime controller" />
              <span className="p-head-text ps-2 text-uppercase" style={{ color: "#7E3AF2" }}>
              Auto-Downtime Controller
              </span>
            </div>
            <p className="p-sub-heading">
            Maximize Your Revenue with Zero Downtime
            </p>
            <div
              className="p-sub-head-bdr"
              style={{ backgroundColor: "#7E3AF2" }}
            ></div>
            <p className="p-body-text">Transform the way you manage your stores across multiple delivery platforms. Voosh offers <strong>real-time visibility into your store's operational hours</strong>, coupled with the <strong>power to directly control it</strong>. This tool is designed to significantly <strong>reduce downtime</strong> and <strong>boost your bottom line</strong>. Keep your stores always on, always earning.</p>
            <Link to="/downtime-controller" onClick={() => {
                    logGoogleEvent("Downtime Controller [Downtime Controller link pressed]", {
                      name: "About us [Downtime Controller link pressed]",
                    });
                  }}>
              <div className="btn btn-outline-primary btn-with-arrow mt-32">
                <font className="pe-2">View Details</font>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path d="M21.5 12H3.5H21.5Z" fill="white" />
                  <path
                    className="stroke-blue"
                    d="M14.5 5L21.5 12M21.5 12L14.5 19M21.5 12H3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-lg-8 col-sm-6 order-lg-1 order-sm-2">
            <div className="finance">
              <img
                className="img-fluid"
                src={DowntimeController}
                alt="Voosh Downtime Controller"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Downtime controller ends */}

      <div className="container-fluid p-s2-container">
        <div
          className="row f-width m-auto products-row ps-0"
          style={{ backgroundColor: "#EDFAFA" }}
        >
          <div className="col-lg-4 col-sm-6 order-lg-2 order-sm-1">
            <div>
              <svg
                className="mb-2"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
              >
                <mask
                  id="mask0_1983_2120"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="32"
                  height="33"
                >
                  <rect y="0.5" width="32" height="32" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1983_2120)">
                  <path
                    d="M9.18204 26.8994C8.95469 27.0823 8.71494 27.0912 8.46281 26.9263C8.21068 26.7613 8.13162 26.5361 8.22564 26.2507L10.3025 19.4431L4.96928 15.6098C4.7197 15.4406 4.64064 15.2132 4.73211 14.9278C4.82355 14.6423 5.01629 14.4995 5.31031 14.4995H11.941L14.0845 7.42786C14.129 7.26717 14.2059 7.15349 14.3153 7.08683C14.4247 7.02016 14.5418 6.98683 14.6666 6.98683C14.7914 6.98683 14.9084 7.02016 15.0178 7.08683C15.1272 7.15349 15.2042 7.26717 15.2486 7.42786L17.3922 14.4995H24.0228C24.3169 14.4995 24.5096 14.6423 24.601 14.9278C24.6925 15.2132 24.6135 15.4406 24.3639 15.6098L19.0306 19.4431L21.1075 26.2507C21.2015 26.5361 21.1225 26.7613 20.8703 26.9263C20.6182 27.0912 20.3785 27.0823 20.1511 26.8994L14.6666 22.7456L9.18204 26.8994ZM11.4666 22.6995L14.6666 20.2457L17.8666 22.6995L16.6666 18.6328L19.6794 16.4995H15.9332L14.6666 12.3662L13.3999 16.4995H9.65374L12.6666 18.6328L11.4666 22.6995ZM25.0049 26.8994L23.8075 25.9892L22.1101 20.4969L25.9357 17.7687H27.4485C27.4348 17.7687 27.5497 17.9157 27.7933 18.2097C28.0369 18.5037 28.0468 18.7268 27.8228 18.879L24.4613 21.2943L25.9818 26.2302C26.0673 26.49 25.9228 26.6673 25.5485 26.7622C25.1741 26.8571 24.9929 26.9028 25.0049 26.8994ZM19.3794 11.8329L18.5973 9.20216L19.1255 7.44066C19.17 7.27999 19.2469 7.16291 19.3563 7.08939C19.4657 7.01588 19.5828 6.97913 19.7076 6.97913C19.8324 6.97913 19.9494 7.0193 20.0588 7.09966C20.1682 7.17999 20.2452 7.29366 20.2896 7.44066L21.6409 11.8329H19.3794Z"
                    fill="#0694A2"
                  />
                </g>
              </svg>
              <span className="p-head-text ps-2" style={{ color: "#0694A2" }}>
                REVIEWS & RATINGS
              </span>
            </div>
            <p className="p-sub-heading">
              Manage your online reputation with ease
            </p>
            <div
              className="p-sub-head-bdr"
              style={{ backgroundColor: "#0694A2" }}
            ></div>
            <p className="p-body-text">
              Voosh's Review Manager allows you to monitor and respond to{" "}
              <font className="fw-bold">
                reviews across all your marketplaces in one place
              </font>
              , helping you maintain a positive brand image. Leverage automated
              replies and enhance customer engagement efficiently
            </p>
            <Link to="/review-rating" onClick={() => {
                    logGoogleEvent("Product features [review rating link pressed]", {
                      name: "About us [review rating link pressed]",
                    });
                  }}>
              <div className="btn btn-outline-primary btn-with-arrow mt-32">
                <font className="pe-2">View Details</font>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path d="M21.5 12H3.5H21.5Z" fill="white" />
                  <path
                    className="stroke-blue"
                    d="M14.5 5L21.5 12M21.5 12L14.5 19M21.5 12H3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-lg-8 col-sm-6 order-lg-1 order-sm-2">
            <div className="r-mgr">
              <img
                className="img-fluid"
                src={ReputationManager}
                alt="Reputation manager"
                style={{ maxWidth: "100%" }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Voosh Reputation manager ends */}

      <div className="container-fluid p-s2-container">
        <div
          className="row f-width m-auto products-row"
          style={{ backgroundColor: "rgba(255, 241, 230, 1)" }}
        >
          <div className="col-lg-4 col-sm-6">
            <div className="d-flex">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><mask id="mask0_2069_1598" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32" style={{maskType:"alpha"}}><rect width="32" height="32" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_2069_1598)"><path d="M10.0047 16.4672C10.4183 15.6399 10.8687 14.8433 11.3559 14.0775C11.8431 13.3117 12.3807 12.5629 12.9688 11.8313L10.9226 11.4134C10.7858 11.3792 10.6534 11.3835 10.5252 11.4262C10.397 11.4689 10.2816 11.5416 10.179 11.6442L6.94312 14.88C6.89183 14.9313 6.87473 14.9911 6.89182 15.0595C6.90891 15.1279 6.95165 15.1792 7.02002 15.2134L10.0047 16.4672ZM25.2765 6.50569C23.2252 6.65269 21.4188 7.10397 19.8572 7.85952C18.2957 8.61508 16.8269 9.68089 15.4508 11.057C14.4662 12.0416 13.6072 13.0672 12.8739 14.1339C12.1406 15.2006 11.5363 16.2604 11.0611 17.3134L14.8354 21.0801C15.8884 20.6048 16.9525 20.0006 18.0277 19.2672C19.1029 18.5339 20.1329 17.6749 21.1175 16.6903C22.4936 15.3142 23.5594 13.851 24.3149 12.3006C25.0705 10.7501 25.5218 8.94928 25.6688 6.89799C25.6688 6.84328 25.6649 6.79286 25.6572 6.74672C25.6495 6.70057 25.6209 6.6527 25.5713 6.60312C25.5217 6.55355 25.4739 6.52491 25.4277 6.51722C25.3816 6.50954 25.3311 6.50569 25.2765 6.50569ZM18.1483 14.0185C17.7568 13.627 17.5611 13.1574 17.5611 12.6095C17.5611 12.0617 17.7568 11.592 18.1483 11.2006C18.5397 10.8091 19.0106 10.6134 19.5611 10.6134C20.1115 10.6134 20.5824 10.8091 20.9739 11.2006C21.3653 11.592 21.5611 12.0617 21.5611 12.6095C21.5611 13.1574 21.3653 13.627 20.9739 14.0185C20.5824 14.41 20.1115 14.6057 19.5611 14.6057C19.0106 14.6057 18.5397 14.41 18.1483 14.0185ZM15.6816 22.1621L16.9354 25.1544C16.9696 25.2228 17.0209 25.2612 17.0893 25.2698C17.1576 25.2783 17.2175 25.257 17.2688 25.2057L20.5047 21.9954C20.6072 21.8929 20.6799 21.7775 20.7226 21.6493C20.7653 21.5211 20.7696 21.3886 20.7354 21.2519L20.3175 19.2057C19.5858 19.7937 18.8371 20.3301 18.0713 20.8147C17.3055 21.2993 16.5089 21.7484 15.6816 22.1621ZM26.9457 6.31079C26.9354 8.53301 26.5141 10.583 25.6816 12.4608C24.8491 14.3386 23.6081 16.1023 21.9585 17.7519C21.873 17.8373 21.7918 17.9142 21.7149 17.9826C21.638 18.051 21.5568 18.1279 21.4713 18.2134L22.0354 20.9749C22.1072 21.3339 22.0893 21.6818 21.9816 22.0185C21.8739 22.3553 21.6901 22.6536 21.4303 22.9134L17.7175 26.6262C17.4525 26.8912 17.1295 26.989 16.7483 26.9198C16.3671 26.8506 16.1047 26.6365 15.9611 26.2775L14.3636 22.5108L9.63799 17.7595L5.87132 16.1621C5.51235 16.0185 5.30122 15.7561 5.23796 15.3749C5.17471 14.9937 5.27557 14.6706 5.54052 14.4057L9.25336 10.6929C9.51318 10.433 9.81276 10.2535 10.1521 10.1544C10.4914 10.0553 10.8405 10.0416 11.1995 10.1134L13.9611 10.6775C14.0465 10.592 14.1192 10.5151 14.179 10.4467C14.2388 10.3783 14.3115 10.3014 14.397 10.2159C16.0465 8.56635 17.8102 7.32105 19.688 6.48002C21.5658 5.639 23.6158 5.21337 25.838 5.20312C25.9816 5.20824 26.1209 5.23687 26.256 5.28902C26.391 5.34116 26.5166 5.42533 26.6329 5.54156C26.7491 5.6578 26.829 5.77918 26.8726 5.90569C26.9162 6.03218 26.9406 6.16721 26.9457 6.31079ZM6.82259 21.557C7.34397 21.0356 7.97773 20.7779 8.72389 20.7839C9.47005 20.7899 10.1038 21.0535 10.6252 21.5749C11.1465 22.0963 11.4059 22.73 11.4034 23.4762C11.4008 24.2223 11.1388 24.8561 10.6175 25.3775C10.1645 25.8305 9.43756 26.2185 8.43669 26.5416C7.43585 26.8647 6.27816 27.0878 4.96362 27.2108C5.08669 25.8963 5.31403 24.7386 5.64566 23.7377C5.97728 22.7369 6.36959 22.01 6.82259 21.557ZM7.77389 22.5262C7.51747 22.7826 7.27815 23.201 7.05592 23.7813C6.8337 24.3617 6.68669 24.9604 6.61489 25.5775C7.232 25.5057 7.83072 25.3557 8.41106 25.1275C8.99139 24.8993 9.40977 24.657 9.66619 24.4006C9.93286 24.1339 10.0688 23.8159 10.0739 23.4467C10.079 23.0775 9.94822 22.7595 9.68156 22.4929C9.41489 22.2262 9.09695 22.0984 8.72772 22.1095C8.3585 22.1206 8.04056 22.2595 7.77389 22.5262Z" fill="#FF5A1F"></path></g></svg>
              <font className="p-head-text ps-2 text-uppercase" style={{ color: "#FF5A1F" }}>
                Ads and Promotions Consulting
              </font>
            </div>
            <p className="p-sub-heading ">
            Drive Exceptional Campaign Results
            </p>
            <div
              className="p-sub-head-bdr"
              style={{ backgroundColor: "#FF5A1F" }}
            ></div>
            <p className="p-body-text"><strong>Configure and manage</strong> all your promotions from a single dashboard. Gain detailed <strong>insights on ads and promotional campaigns</strong> across different channels. With Voosh, you can make informed decisions, customize campaigns as needed, and ensure every dollar spent is an <strong>investment with measurable returns</strong>.</p>
            <Link to="/promotion-manager" onClick={() => {
                    logGoogleEvent("Product features [Promotion manager link pressed]", {
                      name: "About us [Promotion manager link pressed]",
                    });
                  }}>
              <div className="btn btn-outline-primary btn-with-arrow mt-32">
                <font className="pe-2">View Details</font>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path d="M21.5 12H3.5H21.5Z" fill="white" />
                  <path
                    className="stroke-blue"
                    d="M14.5 5L21.5 12M21.5 12L14.5 19M21.5 12H3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-lg-8 col-sm-6">
            <div className="img-dispute">
              <img
                className="img-fluid"
                src={PromotionManager}
                alt="Voosh Dispute Manager"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Voosh Promotion Manager section ends */}
      
      <div className="container-fluid p-s2-container">
        <div
          className="row f-width m-auto products-row"
          style={{ backgroundColor: "#EDFAFA" }}
        >
          <div className="col-lg-4 col-sm-6">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
              >
                <path
                  d="M27 5.5H17V3.5C17 3.23478 16.8946 2.98043 16.7071 2.79289C16.5196 2.60536 16.2652 2.5 16 2.5C15.7348 2.5 15.4804 2.60536 15.2929 2.79289C15.1054 2.98043 15 3.23478 15 3.5V5.5H5C4.46957 5.5 3.96086 5.71071 3.58579 6.08579C3.21071 6.46086 3 6.96957 3 7.5V22.5C3 23.0304 3.21071 23.5391 3.58579 23.9142C3.96086 24.2893 4.46957 24.5 5 24.5H9.92L7.21875 27.875C7.05299 28.0822 6.97633 28.3468 7.00563 28.6105C7.03493 28.8742 7.1678 29.1155 7.375 29.2812C7.5822 29.447 7.84676 29.5237 8.11049 29.4944C8.37421 29.4651 8.61549 29.3322 8.78125 29.125L12.48 24.5H19.52L23.2188 29.125C23.3008 29.2276 23.4023 29.313 23.5174 29.3764C23.6325 29.4398 23.7589 29.4799 23.8895 29.4944C24.0201 29.5089 24.1523 29.4975 24.2785 29.461C24.4046 29.4244 24.5224 29.3633 24.625 29.2812C24.7276 29.1992 24.813 29.0977 24.8764 28.9826C24.9398 28.8675 24.9799 28.7411 24.9944 28.6105C25.0089 28.4799 24.9975 28.3477 24.961 28.2215C24.9244 28.0954 24.8633 27.9776 24.7812 27.875L22.08 24.5H27C27.5304 24.5 28.0391 24.2893 28.4142 23.9142C28.7893 23.5391 29 23.0304 29 22.5V7.5C29 6.96957 28.7893 6.46086 28.4142 6.08579C28.0391 5.71071 27.5304 5.5 27 5.5ZM27 22.5H5V7.5H27V22.5ZM13 15.5V18.5C13 18.7652 12.8946 19.0196 12.7071 19.2071C12.5196 19.3946 12.2652 19.5 12 19.5C11.7348 19.5 11.4804 19.3946 11.2929 19.2071C11.1054 19.0196 11 18.7652 11 18.5V15.5C11 15.2348 11.1054 14.9804 11.2929 14.7929C11.4804 14.6054 11.7348 14.5 12 14.5C12.2652 14.5 12.5196 14.6054 12.7071 14.7929C12.8946 14.9804 13 15.2348 13 15.5ZM17 13.5V18.5C17 18.7652 16.8946 19.0196 16.7071 19.2071C16.5196 19.3946 16.2652 19.5 16 19.5C15.7348 19.5 15.4804 19.3946 15.2929 19.2071C15.1054 19.0196 15 18.7652 15 18.5V13.5C15 13.2348 15.1054 12.9804 15.2929 12.7929C15.4804 12.6054 15.7348 12.5 16 12.5C16.2652 12.5 16.5196 12.6054 16.7071 12.7929C16.8946 12.9804 17 13.2348 17 13.5ZM21 11.5V18.5C21 18.7652 20.8946 19.0196 20.7071 19.2071C20.5196 19.3946 20.2652 19.5 20 19.5C19.7348 19.5 19.4804 19.3946 19.2929 19.2071C19.1054 19.0196 19 18.7652 19 18.5V11.5C19 11.2348 19.1054 10.9804 19.2929 10.7929C19.4804 10.6054 19.7348 10.5 20 10.5C20.2652 10.5 20.5196 10.6054 20.7071 10.7929C20.8946 10.9804 21 11.2348 21 11.5Z"
                  fill="#0694A2"
                />
              </svg>
              <font className="p-head-text ps-2 text-capitalize" style={{ color: "#0694A2" }}>
                ANALYTICS & INSIGHTS
              </font>
            </div>
            <p className="p-sub-heading">
              Unlock the Power of Data with Analytics & Insights
            </p>
            <div
              className="p-sub-head-bdr"
              style={{ backgroundColor: "#0694A2" }}
            ></div>
            <p className="p-body-text">
              Dive deep into your performance across all marketplaces with our
              analytics tool. Understand your sales trends, identify
              top-performing items, and{" "}
              <font className="fw-bold">discover opportunities for growth</font>
              . Get actionable insights that empower you to make data-driven
              decisions that boost your profitability.
            </p>
            <Link to="/analytics-insights" onClick={() => {
                    logGoogleEvent("Product features [analytics insights link pressed]", {
                      name: "About us [analytics insights link pressed]",
                    });
                  }}>
              <div className="btn btn-outline-primary btn-with-arrow mt-32">
                <font className="pe-2">View Details</font>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path d="M21.5 12H3.5H21.5Z" fill="white" />
                  <path
                    className="stroke-blue"
                    d="M14.5 5L21.5 12M21.5 12L14.5 19M21.5 12H3.5"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
          <div className="col-lg-8 col-sm-6">
            <div className="p-analtytics">
              <img
                className="img-fluid"
                src={AnalyticsInsights}
                alt="Voosh Dispute Manager"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Voosh analytics and insights section ends */}

    </>
  );
};

export default Section2;
